/* eslint-disable react/no-string-refs */
/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component, Fragment } from "react";
import "./ManualPayments.css";
import PropTypes from "prop-types";
import { ENVIRONMENT } from "../../config";

class ManualPayments extends Component {
  constructor(props) {
    super(props);
    try {
      if (this.props.location.state.amount) {
        this.state = {
          fetching: false,
          status: "",
          buttonClick: false,
          loading: false,
          selectedOption: "",
          methodKey: "",
          hasHongKong: false,
          hasChina: false,
          ...this.props.location.state,
          debugOverrideQR: null,
          debugOverrideLink: null,
          fileUploaded: false,
          uploadedFileName: "",
          file: null,
          paymentReference: "",
        };

        this.onNextBtnClicked = this.onNextBtnClicked.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.handleFileUpload = this.handleFileUpload.bind(this);
        this.handleRemoveFile = this.handleRemoveFile.bind(this);
      }
    } catch (e) {
      this.props.history.push({
        pathname: "/ManualPayments",
      });
    }
  }

  componentDidMount() {
    const {
      initialOption, initialMethodKey, hasHongKong, hasChina
    } = this.mapPaymentMethod();

    this.setState({
      selectedOption: initialOption,
      methodKey: initialMethodKey,
      hasHongKong,
      hasChina,
    });
  }

  isNextDisabled() {
    if (!this.state.fileUploaded) return true;

    const requireTransactionId = this.state.organization && this.state.organization.requireTransactionId;
    if (requireTransactionId && !this.state.paymentReference.trim()) return true;

    return false;
  }

  onNextBtnClicked(e) {
    e.preventDefault();
    if (this.isNextDisabled()) return;

    // Capture methodKey before setState to avoid race condition (React 18 fix)
    const methodKey = this.state.methodKey;

    this.setState({
      buttonClick: true,
      loading: true,
    });

    const dataObj = {
      ...this.props.location.state,
      brand: methodKey,
      methodKey: methodKey,
      // Preserve transaction type
      transactionType: this.props.location.state.transactionType || 'donation',
      // Pass file upload and payment reference to Review
      fileUploaded: this.state.fileUploaded,
      uploadedFileName: this.state.uploadedFileName,
      file: this.state.file,
      paymentReference: this.state.paymentReference,
    };
    // console.log(JSON.stringify(dataObj) + " -60 Manual Payments");
    this.props.history.push({
      pathname: "/Review",
      state: dataObj,
    });
  }

  handleSelectChange(e) {
    const selectedOption = e.target.value;
    const methodKey = `${this.state.brand}_${selectedOption}`;
    this.setState({ selectedOption, methodKey });
  }

  handleFileUpload(e) {
    const file = e.target.files[0];
    if (file) {
      this.setState({ fileUploaded: true, uploadedFileName: file.name, file });
    }
  }

  handleRemoveFile() {
    this.setState({ fileUploaded: false, uploadedFileName: "", file: null });
  }

  getPaymentMethodCodeUrl() {
    const { organization, methodKey } = this.state;
    if (organization.paymentMethodCode[methodKey]) {
      return organization.paymentMethodCode[methodKey].code;
    }
    return '';
  }

  mapPaymentMethod() {
    const { brand, organization } = this.state;

    let initialOption = "ch";
    let initialMethodKey = brand;
    let hasHongKong = false;
    let hasChina = false;

    if (brand === "alipay" || brand === "wechatpay") {
      // Check if organization.paymentMethodCode exists first
      if (organization && organization.paymentMethodCode) {
        // Check for specific region variants (HK and China)
        hasHongKong = organization.paymentMethodCode[`${brand}_hk`] && organization.paymentMethodCode[`${brand}_hk`].enabled;

        hasChina = organization.paymentMethodCode[`${brand}_ch`] && organization.paymentMethodCode[`${brand}_ch`].enabled;

        if (hasHongKong) {
          initialOption = "hk";
          initialMethodKey = `${brand}_hk`;
        } else {
          initialMethodKey = `${brand}_ch`;
        }
      }
    }

    return {
      initialOption,
      initialMethodKey,
      hasHongKong,
      hasChina,
    };
  }

  getBankTransferDetails() {
    const { organization } = this.state;
    const languageObj = this.props.languageObj;

    let bankDetails = [];

    if (
      organization &&
      organization.paymentMethodCode &&
      organization.paymentMethodCode.bank_transfer
    ) {
      bankDetails = [
        {
          label: languageObj.bankCode,
          value: organization.paymentMethodCode.bank_transfer.bankTransferCode || '',
        },
        {
          label: languageObj.branchCode,
          value: organization.paymentMethodCode.bank_transfer.bankTransferBranchCode || '',
        },
        {
          label: languageObj.accountNumber,
          value: organization.paymentMethodCode.bank_transfer.bankTransferAccountNumber || '',
        },
        {
          label: languageObj.accountName,
          value: organization.paymentMethodCode.bank_transfer.bankTransferAccountName || '',
        },
      ];
    }

    return bankDetails;
  }

  getCheckWritingDetails() {
    const { organization } = this.state;
    const languageObj = this.props.languageObj;

    let checkWritingDetails = [];

    if (
      organization &&
      organization.paymentMethodCode &&
      organization.paymentMethodCode.check_writing
    ) {
      checkWritingDetails = [
        {
          label: languageObj.organizationName,
          value: organization.paymentMethodCode.check_writing.checkWritingOrgName || '',
        },
        {
          label: languageObj.instructions,
          value: organization.paymentMethodCode.check_writing.checkWritingInstructions || '',
        },
      ];
    }

    return checkWritingDetails;
  }

  getPaypalManualDetails() {
    const { organization } = this.state;
    const languageObj = this.props.languageObj;

    let paypalManualDetails = [];

    if (
      organization &&
      organization.paymentMethodCode &&
      organization.paymentMethodCode.paypal_manual
    ) {
      paypalManualDetails = [
        {
          label: languageObj.organizationName || 'PayPal Account',
          value: organization.paymentMethodCode.paypal_manual.paypalManualOrgName || '',
        },
        {
          label: languageObj.instructions || 'Instructions',
          value: organization.paymentMethodCode.paypal_manual.paypalManualInstructions || '',
        },
      ];
    }

    return paypalManualDetails;
  }

  render() {
    /* if (this.state.fetching || this.state.loading) {
      return <this.props.RenderFullPageLoading />;
    }
      */

    let paymentMethodCodeUrl = this.getPaymentMethodCodeUrl();

    // Debug overrides
    if (this.state.debugOverrideQR === true) paymentMethodCodeUrl = paymentMethodCodeUrl || 'debug-placeholder';
    if (this.state.debugOverrideQR === false) paymentMethodCodeUrl = '';

    const languageObj = this.props.languageObj;

    const paymentMethodNames = languageObj.paymentMethodNames || {
      alipay: 'Alipay',
      wechatpay: 'WeChat Pay',
      bocpay: 'BoC Pay',
      octopus: 'Octopus',
      fps: "FPS",
      bank_transfer: "Bank Transfer",
      check_writing: "Cheque",
      cash: "Cash",
      paypal_manual: "PayPal",
    };

    const paymentMethodColors = {
      alipay: { background: '#00A1ED', text: '#00A1ED' },
      wechatpay: { background: '#51AA38', text: '#51AA38' },
      bocpay: { background: '#892130', text: '#892130' },
      octopus: { background: '#FF8600', text: '#FF8600' },
      fps: { background: '#508ABA', text: '#508ABA' },
      bank_transfer: { background: '#79C462', text: '#79C462' },
      check_writing: { background: '#34B7BC', text: '#34B7BC' },
      cash: { background: '#9f9f9f', text: '#9f9f9f' },
      paypal_manual: { background: '#003087', text: '#003087' },
    };

    const backContainerStyle = {
      backgroundColor: paymentMethodColors[this.state.brand].background || '#FFFFFF', // Default color if brand is not found
    };

    const backContainerTextStyle = {
      color: paymentMethodColors[this.state.brand].text || '#FFFFFF', // Default color if brand is not found
    };

    const qrView = () => {
      if (
        this.state.brand === "bank_transfer" ||
        this.state.brand === "check_writing" ||
        this.state.brand === "cash" ||
        (this.state.brand === "paypal_manual" && !paymentMethodCodeUrl)
      ) {
        return null;
      }

      return (
        <Fragment>
          <div className="ManualPayments-text">
            <p>{languageObj.scanCodeWith} {paymentMethodNames[this.state.brand]}</p>
            <strong>HK${this.state.amount}</strong>

            {this.state.brand === "alipay" || this.state.brand === "wechatpay" ? (
              <select
                className="ManualPayments-select"
                onChange={this.handleSelectChange}
              >
                {this.state.hasHongKong && (
                  <option value="hk">{languageObj.hongKong}</option>
                )}
                {this.state.hasChina && (
                  <option value="ch">{languageObj.china}</option>
                )}
              </select>
            ) : null}
          </div>
          <div
            className="ManualPayments-QR" style={{
              backgroundImage: `url(${paymentMethodCodeUrl})`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
            }}
          />
        </Fragment>
      );
    };

    const detailsView = () => {
      if (this.state.brand === "bank_transfer" || this.state.brand === "check_writing") {
        const details = this.state.brand === "bank_transfer" ? this.getBankTransferDetails() : this.getCheckWritingDetails();

        return (
          <div className="ManualPayments-detailsContainer">
            {details.map((detail, index) => (
              <div key={index} className="ManualPayments-detailRow">
                <div className="ManualPayments-detailLabel">{detail.label}</div>
                <div className="ManualPayments-detailValue">{detail.value}</div>
              </div>
            ))}
          </div>
        );
      }

      return null;
    };

    const paypalLinkView = () => {
      if (this.state.brand !== 'paypal_manual' || !hasPaypalLink) return null;

      return (
        <div style={{ textAlign: 'center', marginTop: '20px', marginBottom: '10px' }}>
          {!hasPaypalQR && (
            <div className="ManualPayments-text" style={{ marginBottom: '20px' }}>
              <p>{hasPaypalLink
                ? (languageObj.followPayPalLink || 'Click the PayPal button below to make your payment')
                : (languageObj.payViaPayPal || 'Pay via PayPal using the details provided')
              }</p>
              <strong>HK${this.state.amount}</strong>
              {this.state.organization &&
                this.state.organization.paymentMethodCode &&
                this.state.organization.paymentMethodCode.paypal_manual &&
                this.state.organization.paymentMethodCode.paypal_manual.paypalManualInstructions && (
                <p style={{ fontSize: '12px', color: '#666', marginTop: '10px', whiteSpace: 'pre-wrap' }}>
                  {this.state.organization.paymentMethodCode.paypal_manual.paypalManualInstructions}
                </p>
              )}
            </div>
          )}
          <a
            href={hasPaypalLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-block',
              padding: '12px 30px',
              backgroundColor: '#003087',
              color: '#ffffff',
              borderRadius: '25px',
              textDecoration: 'none',
              fontSize: '14px',
              fontWeight: '600',
            }}
          >
            {languageObj.payWithPayPal || 'Pay with PayPal'}
          </a>
        </div>
      );
    };

    const hasPaypalQR = this.state.brand === 'paypal_manual' && !!paymentMethodCodeUrl;
    let hasPaypalLink = this.state.brand === 'paypal_manual' &&
      this.state.organization &&
      this.state.organization.paymentMethodCode &&
      this.state.organization.paymentMethodCode.paypal_manual &&
      this.state.organization.paymentMethodCode.paypal_manual.paypalManualLink;

    // Debug override for link
    if (this.state.debugOverrideLink === true) hasPaypalLink = hasPaypalLink || 'https://paypal.com/debug';
    if (this.state.debugOverrideLink === false) hasPaypalLink = false;

    const description1View = () => {
      let text = '';

      if (this.state.brand === 'paypal_manual') {
        if (hasPaypalQR && hasPaypalLink) {
          text = languageObj.scanOrFollowLink || 'Scan the QR code or follow the link below to pay with PayPal';
        } else if (hasPaypalQR) {
          text = `${languageObj.scanCodeWith} ${paymentMethodNames[this.state.brand]}`;
        } else if (hasPaypalLink) {
          text = languageObj.followPayPalLink || 'Click the PayPal button below to make your payment';
        } else {
          text = languageObj.payViaPayPal || 'Pay via PayPal using the details provided';
        }
      } else if (
        this.state.brand === 'alipay' ||
        this.state.brand === 'wechatpay' ||
        this.state.brand === 'bocpay' ||
        this.state.brand === 'octopus' ||
        this.state.brand === 'fps'
      ) {
        text = `${languageObj.scanCodeWith} ${paymentMethodNames[this.state.brand]}`;
      } else if (this.state.brand === 'bank_transfer') {
        text = languageObj.openBankingApp;
      } else if (this.state.brand === 'check_writing') {
        text = languageObj.prepareCheck;
      }

      return (
        <div className="ManualPayments-textContainer">
          <div className="ManualPayments-circle">1</div>
          <div className="ManualPayments-text4">
            {text}
          </div>
        </div>
      );
    };

    const description2View = () => {
      let text = '';

      if (this.state.brand === 'paypal_manual') {
        text = languageObj.completePayPalPayment || 'Complete the payment and take a screenshot of the confirmation';
      } else if (
        this.state.brand === 'alipay' ||
        this.state.brand === 'wechatpay' ||
        this.state.brand === 'bocpay' ||
        this.state.brand === 'octopus' ||
        this.state.brand === 'fps'
      ) {
        text = languageObj.scanToAuthorise;
      } else if (this.state.brand === 'bank_transfer') {
        text = languageObj.enterBankingDetails;
      } else if (this.state.brand === 'check_writing') {
        text = languageObj.depositCheck;
      }

      return (
        <div className="ManualPayments-textContainer">
          <div className="ManualPayments-circle">2</div>
          <div className="ManualPayments-text5">
            {text}
          </div>
        </div>
      );
    };

    const description3View = () => {
      return (
        <div className="ManualPayments-textContainer">
          <div className="ManualPayments-circle">3</div>
          <div className="ManualPayments-text6">
            {this.state.brand === "check_writing" ? (
              languageObj.screenshotReceipt
            ): languageObj.screenshotMethodReceipt.replace('{{method}}', paymentMethodNames[this.state.brand]) }
          </div>
        </div>
      );
    };

    const description4View = () => {
      return (
        <div className="ManualPayments-textContainer">
          <div className="ManualPayments-circle">4</div>
          <div className="ManualPayments-text6">
            {languageObj.comeBackText}
          </div>
        </div>
      );
    };

    const isDebug = ['local', 'dev'].includes(ENVIRONMENT);

    const debugView = () => {
      if (!isDebug) return null;

      const paypalData = this.state.organization &&
        this.state.organization.paymentMethodCode &&
        this.state.organization.paymentMethodCode.paypal_manual;

      const btnStyle = (active) => ({
        padding: '3px 8px', margin: '0 4px', cursor: 'pointer', border: '1px solid #555',
        borderRadius: '3px', fontSize: '10px', fontFamily: 'monospace',
        background: active ? '#0f0' : '#333', color: active ? '#000' : '#e0e0e0',
      });
      const btnStyleOff = (active) => ({
        ...btnStyle(active),
        background: active ? '#f55' : '#333', color: active ? '#fff' : '#e0e0e0',
      });
      const btnStyleReset = {
        padding: '3px 8px', margin: '0 4px', cursor: 'pointer', border: '1px solid #555',
        borderRadius: '3px', fontSize: '10px', fontFamily: 'monospace',
        background: '#555', color: '#e0e0e0',
      };

      return (
        <div style={{
          position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
          background: '#1a1a2e', color: '#e0e0e0', padding: '12px 16px',
          fontSize: '11px', fontFamily: 'monospace', borderTop: '2px solid #e94560',
          maxHeight: '200px', overflowY: 'auto'
        }}>
          <div style={{ color: '#e94560', fontWeight: 'bold', marginBottom: '6px' }}>DEBUG — ManualPayments</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 16px' }}>
            <div>Brand: <span style={{ color: '#0ff' }}>{this.state.brand}</span></div>
            <div>Language: <span style={{ color: '#0ff' }}>{this.state.language || this.props.language || 'unknown'}</span></div>
            <div>Method Key: <span style={{ color: '#0ff' }}>{this.state.methodKey}</span></div>
            <div>Amount: <span style={{ color: '#0ff' }}>{this.state.amount}</span></div>
          </div>
          <div style={{ marginTop: '8px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
            <span>QR Code: <span style={{ color: paymentMethodCodeUrl ? '#0f0' : '#f55' }}>{paymentMethodCodeUrl ? 'Yes' : 'No'}</span></span>
            <button style={btnStyle(this.state.debugOverrideQR === true)} onClick={() => this.setState({ debugOverrideQR: true })}>Force ON</button>
            <button style={btnStyleOff(this.state.debugOverrideQR === false)} onClick={() => this.setState({ debugOverrideQR: false })}>Force OFF</button>
            <button style={btnStyleReset} onClick={() => this.setState({ debugOverrideQR: null })}>Reset</button>
          </div>
          {this.state.brand === 'paypal_manual' && (
            <Fragment>
              <div style={{ marginTop: '6px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                <span>PayPal Link: <span style={{ color: hasPaypalLink ? '#0f0' : '#f55' }}>{hasPaypalLink || 'No'}</span></span>
                <button style={btnStyle(this.state.debugOverrideLink === true)} onClick={() => this.setState({ debugOverrideLink: true })}>Force ON</button>
                <button style={btnStyleOff(this.state.debugOverrideLink === false)} onClick={() => this.setState({ debugOverrideLink: false })}>Force OFF</button>
                <button style={btnStyleReset} onClick={() => this.setState({ debugOverrideLink: null })}>Reset</button>
              </div>
              <div style={{ marginTop: '4px' }}>
                <span>Org Name: <span style={{ color: '#0ff' }}>{paypalData ? paypalData.paypalManualOrgName || '-' : '-'}</span></span>
                {' | '}
                <span>Instructions: <span style={{ color: '#0ff' }}>{paypalData ? paypalData.paypalManualInstructions || '-' : '-'}</span></span>
              </div>
            </Fragment>
          )}
        </div>
      );
    };

    return (
      <div className="ManualPayments-view">
        {debugView()}
        <div className="ManualPayments-prompt">
          <div className="ManualPayments-view1">
            <div
              className="ManualPayments-backContainer"
              onClick={() => {
                const dataObj = this.state;
                this.props.history.push({
                  pathname: "/SelectPayment",
                  state: dataObj,
                });
              }}
            >
              <div className="ManualPayments-back" >
                <div className="ManualPayments-backBtn" style={backContainerStyle} />
                <div className="ManualPayments-backText" style={backContainerTextStyle}>{languageObj.backText}</div>
              </div>
            </div>
            <div className={`ManualPayments-paymentNetwork ${this.state.brand}`} />

            {qrView()}
            {paypalLinkView()}
            {detailsView()}

            <div className="ManualPayments-text">{languageObj.text2}</div>
          </div>

          <div className="ManualPayments-view2">
            <div className="ManualPayments-description">
              <div className="ManualPayments-text3">
                {languageObj.payingWith} {paymentMethodNames[this.state.brand]}
              </div>

              {description1View()}
              {description2View()}
              {description3View()}
              {description4View()}

            </div>

            {this.state.fileUploaded ? (
              <div className="ManualPayments-uploadSection">
                <div className="ManualPayments-uploadSuccess">
                  {languageObj.documentUploaded || "Document uploaded:"} {this.state.uploadedFileName}
                  <button onClick={this.handleRemoveFile} className="ManualPayments-removeFileBtn">
                    {languageObj.removeFile || "Remove"}
                  </button>
                </div>
              </div>
            ) : (
              <div className="ManualPayments-uploadSection">
                <div className="ManualPayments-uploadIcon" />
                <div className="ManualPayments-uploadText">
                  {languageObj.uploadSupportingDocument || "Upload supporting document"}
                </div>
                <input
                  type="file"
                  ref={(input) => (this.fileInput = input)}
                  style={{ display: "none" }}
                  onChange={this.handleFileUpload}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <button
                  className="ManualPayments-uploadBtn"
                  onClick={() => this.fileInput.click()}
                >
                  {languageObj.uploadProofOfPayment || "Upload Proof of Payment"}
                </button>
              </div>
            )}

            {(() => {
              const requireTransactionId = this.state.organization && this.state.organization.requireTransactionId;
              return (
                <div className="ManualPayments-transactionIdSection">
                  <div className="ManualPayments-transactionIdLabel">
                    {languageObj.paymentReference || "Payment Reference"}
                    <span className={`ManualPayments-optionalTag${requireTransactionId ? ' required' : ''}`}>
                      {requireTransactionId
                        ? (languageObj.required || "(Required)")
                        : (languageObj.optional || "(Optional)")}
                    </span>
                  </div>
                  <input
                    type="text"
                    className="ManualPayments-transactionIdInput"
                    value={this.state.paymentReference}
                    onChange={(e) => this.setState({ paymentReference: e.target.value })}
                    placeholder={languageObj.paymentReferencePlaceholder || "Enter payment reference"}
                  />
                </div>
              );
            })()}

            <div
              className={`ManualPayments-nextBtn${this.isNextDisabled() ? ' ManualPayments-nextBtn--disabled' : ''}`}
              style={backContainerStyle}
              onClick={this.onNextBtnClicked}
            >
              {languageObj.nextText}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ManualPayments.propTypes = {
  languageObj: PropTypes.object,
  language: PropTypes.string,
  RenderFullPageLoading: PropTypes.func,
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default ManualPayments;
